// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = require('../internals/add-to-unscopables');

addToUnscopables('flatMap');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es.array.unscopables.flat-map.js
// module id = 436
// module chunks = 4